import React from "react";
import FILTVViewerCounter from "./FILTVViewerCounter";
import FILTVOfferTimer from "./FILTVOfferTimer";

export default function FILTVOverlayInfo({ channel, ad }) {
    return (
        <div className="absolute right-2 top-2 w-28 sm:w-40 rounded-lg bg-black/70 backdrop-blur p-2 border border-zinc-700">
            <div className="text-red-500 text-[10px] sm:text-xs font-bold animate-pulse">
                🔴 LIVE
            </div>

            <FILTVViewerCounter seed={channel?.lcn} />

            {ad?.offerEndsInMinutes != null && (
                <FILTVOfferTimer minutes={ad.offerEndsInMinutes} channelKey={channel?.lcn} />
            )}
        </div>
    );
}
